import React, { Component } from 'react';
import img_l from '../../../assets/images/arrow_right.png';
import img_r from '../../../assets/images/arrow_left.png';
import img_scroll from '../../../assets/images/button_element.png';
import { Link } from "react-router-dom";
import "./Arrow.css";

export default class Slider extends Component{

	constructor(props){
		super(props);
		let data = {slides: [], ...props.data};
		data.slides = Array.isArray(data.slides) ? data.slides : JSON.parse(data.slides);
		this.state = {
			slides: data.slides,
		}

	}

	render(){
			var carouselControl = (this.state.slides.length > 1) ?
			<div><a className="left carousel-control" href="#carousel-example-generic" data-slide="prev"><img src={img_l} alt="nifc"/></a>
			<a className="right carousel-control" href="#carousel-example-generic" data-slide="next"><img src={img_r} alt="nifc"/></a></div>:'';

			const customLogo = this.props.icon ? (
			<div className="custom-logo-container">
				<a aria-label="Patreon" className="block-a" target="_blank" style={{backgroundImage: `url(${this.props.icon.image})`}} href={this.props.icon.url}></a>
			</div>) : null;

			return (
			<div className="karuzela">
				<center className="roller"><img src={img_scroll} className="rollerPointer" alt="nifc"/></center>
				<div id="carousel-example-generic" className="carousel slide">
					<div className="carousel-inner">

						{this.state.slides.map(function(object, i){

							var img = object.img;

							if(i === 0){
								return(

									<div className="item active" key={i}>
											<div className="slaider-bgimage" style={{backgroundImage: "url("+ img +")"}}></div>
										<div className="carousel-caption">
											<div className="container">
												<div className="row">
									 				<div className="hidden-xs hidden-sm col-md-2 col-lg-2"></div>
													<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 slider-title">
														<a className="no-hover" href={object.url}>
															<div className="headerinfo-block">
																<p className="headerinfo-title" dangerouslySetInnerHTML={{ __html: object.title }} />
																<h1 className="headerinfo-content" dangerouslySetInnerHTML={{ __html: object.description }} />
																<p className="headerinfo-timeref">
																	{object.date}
																</p>
															</div>
														</a>
													</div>
													<div className="hidden-xs hidden-sm col-md-3 col-lg-3"></div>
												</div>
											</div>
										</div>
										{customLogo}

									</div>

								);
							}
							return(

									<div className="item" key={i}>

										<div className="slaider-bgimage" style={{backgroundImage: "url("+ img +")"}}></div>

										<div className="carousel-caption">
											<div className="container">
												<div className="row">
													<div className="col-sm-3 col-md-2 col-lg-2"></div>
													<div className="col-xs-12 col-sm-9 col-md-6 col-lg-6">
														<a className="no-hover" href={object.url}>
															<div className="headerinfo-block">
																<p className="headerinfo-title" dangerouslySetInnerHTML={{ __html: object.title }} />
																<h1 className="headerinfo-content" dangerouslySetInnerHTML={{ __html: object.description }} />
																<p className="headerinfo-timeref">
																	{object.date}
																</p>
															</div>
														</a>
													</div>
													<div className="col-sm-3 col-md-3 col-lg-3"></div>
												</div>
											</div>
										</div>
										{customLogo}
									</div>

								);

						})}

						{carouselControl}


				</div>
			</div>
		</div>


				);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Elements/Slider/Slider.js